<template>
  <div>
    <fragment v-if="isTimeline">
      <proposta-expandida-timeline
        :timeline="proposal.timeline"
        :status="proposal.status"
        :textButton="'Preencher'"
        @action-button="$emit('reanalysis', proposal)"
      />
      <v-layout row wrap v-if="acompanhamento">
        <v-flex class="xs12">
          <h3 class="header_acoes">Histórico</h3>
          <proposta-expandida-acompanhamento
            :followups="proposal.acompanhamento"
            :timeline="true"
          />
        </v-flex>
      </v-layout>
    </fragment>

    <proposta-expandida-informacoes
      v-if="isProposalInformation"
      :tomador="proposal.tomador"
      :segurado="proposal.segurado"
      :modalidades="proposal.modalidades"
      :coberturas="proposal.coberturas"
      :tags="proposal.tags"
      :objeto="proposal.objeto"
    />

    <proposta-expandida-acompanhamento
      v-if="isHistoric"
      :followups="proposal.acompanhamento"
    />

    <processo-analise-credito
      v-if="isCreditAnalyse"
      :item="
        proposal.tomador_credito ? proposal.tomador_credito : proposal.tomador
      "
      :pendencias="proposal.pendencias"
      :slug="proposal.grupo_credito.slug"
      @getDocumentosSucessoModal="getDocumentosSucessoModal()"
    ></processo-analise-credito>

    <processo-analise-subscricao
      v-if="isSubscriptionAnalyse"
      :pendencias="proposal.pendencias"
      :is-endorsement="isEndorsement"
      @getDocumentosSucessoModal="getDocumentosSucessoModal()"
    ></processo-analise-subscricao>
 
    <processo-analise-resseguro
      v-if="isReinsuringAnalyse"
      :pendencias="proposal.pendencias"
      @getDocumentosSucessoModal="getDocumentosSucessoModal()"
    ></processo-analise-resseguro>
  </div>
</template>

<script lang="js">
export default {
  name:  "DocumentInformation",
  props: {
    proposal: { type: Object },
    tabIndex: { type: String },
    acompanhamento: { type: Boolean },
    isEndorsement: { type: Boolean, default: false },
  },
  computed: {
    isTimeline() { return this.isTabIndex("Timeline"); },
    isProposalInformation() { return this.isTabIndex("Informações da Proposta"); },
    isHistoric () { return this.isTabIndex("Histórico Geral"); },
    isReinsuringAnalyse() { return this.isTabIndex('Analise de Resseguro'); },
    isCreditAnalyse() { return this.isTabIndex('Formulário de Crédito'); },
    isSubscriptionAnalyse() { return this.isTabIndex("Analise de Subscrição"); }
  },
  methods: {
    isTabIndex(index) { return this.tabIndex == index; },
    getDocumentosSucessoModal() {}
  }
};
</script>



// WEBPACK FOOTER //
// ./src/components/DocumentInformation.vue